import { css } from '@emotion/react';
import { faEraser } from '@fortawesome/pro-solid-svg-icons';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import { useTranslation } from '~/_shared/utils/hooks';

const filterHeaderStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  overflow: 'visible',
  minWidth: 0,
  maxWidth: 237,
});

const nameStyle = css({
  flex: 1,
  minWidth: 0, // Allow the text container to shrink
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const buttonContainerStyle = css({
  flexShrink: 0, // Prevent the button from shrinking
});

type FilterHeaderComponentProps = Readonly<{
  name: string;
  onClearClick?: () => void;
}>;

export const FilterHeaderComponent = ({
  name,
  onClearClick,
}: FilterHeaderComponentProps) => {
  const [t] = useTranslation();

  const isDisabled = !onClearClick;

  return (
    <div css={filterHeaderStyle}>
      <span css={nameStyle}>{name}</span>
      <div css={buttonContainerStyle}>
        <RoundButtonComponent
          tooltipLabel={isDisabled ? undefined : t('Clear')}
          icon={faEraser}
          onClick={onClearClick}
          isDisabled={isDisabled}
          size={RoundButtonSize.Small}
          buttonStyle={isDisabled ? RoundButtonStyle.Disabled : RoundButtonStyle.Danger}
        />
      </div>
    </div>
  );
};
